// 线索相关
import request from '@/utils/request'
/**
 * 门店线索管理分页查询接口
 * @param {*} data
 * @param {string} params.storeName - 门店名称
 * @returns
 */
export function storeClueConfigList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/store/clue/config/list',
    method: 'POST',
    data,
  })
}
/**
 * 线索配置保存前的校验接口，校验配置的销售人员是否符合预期
 * @param {*} data
 * @param {number} data.storeId - 门店id
 * @param {array} data.employeeIdList - 选中的销售人员id集合
 */
export function storeClueConfigCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/store/clue/config/checkV2',
    method: 'POST',
    data,
  })
}

/**
 * 门店线索配置保存
 * @param {*} data
 * @param {number} data.storeId - 门店id
 * @param {object} data.configInfo - 回收规则配置
 * @param {number} data.configInfo.firstTimeOut - 回收规则配置-首次跟进超时时间
 * @param {number} data.configInfo.frequencyDay - 回收规则配置-跟进频率天数
 * @param {number} data.configInfo.frequencyNum - 回收规则配置-跟进频率次数
 * @param {array} data.employeeIdList - 选中的销售人员id集合
 * @returns
 */
export function storeClueConfigSave(data = {}) {
  return request({
    url: '/admin/v1/vehicle/store/clue/config/save',
    method: 'POST',
    data,
  })
}

/**
 * 门店线索配置详情
 * @param {*} data
 * @param {number} data.storeId - 门店id
 * @returns
 */
export function storeClueConfigDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/store/clue/config/detail',
    method: 'POST',
    data,
  })
}
/**
 * 门店线索数据看板
 * @param {*} data
 * @param {number} data.storeId - 门店id
 * @param {number} data.dayRange - 近x天的数据，取值为1，7，30
 * @returns
 */
export function clueDashboard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/dashboard',
    method: 'POST',
    data,
  })
}

/**
 * 门店线索数据看板 门店列表
 * @returns
 */
export function storeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/dashboard/store/list',
    method: 'POST',
    data,
  })
}

// 获取线索标签
export function clueLabelList() {
  return request({
    url: '/admin/v1/vehicle/clue/vm/label',
    method: 'POST',
  })
}
